<template lang='pug'>
    h1.has-text-centered {{ this.time }}
</template>

<script>
import moment from 'moment'
import { API } from '../services'

export default {
  mounted: function () {
    this.$nextTick(function () {
      this.getTime()
    })
  },
  data () {
    return {
      time: null,
      worker: null
    }
  },
  methods: {
    async getTime () {
      const { accessData } = this.$store.state

      let id

      if (accessData.browserId) {
        id = accessData.browserId
      } else if (accessData.compMan) {
        id = accessData.compMan.id
      }

      this.updateTimeWorker(id)

      document.addEventListener("visibilitychange", () => {
        if (!document.hidden){
          this.worker.terminate()
          this.updateTimeWorker(id)
        }
      })
    },
    async updateTimeWorker (id) {
      this.worker = new Worker('/js/currentTimeWorker.js')

      let date

      try {
        const result = await API.getTime.get({id})
        date = moment(result.body.time).toDate()
      } catch (e) {
        date = new Date()
      }

      this.worker.postMessage(date.toISOString())

      this.worker.addEventListener('message', (e) => {
        this.time = e.data
      })
    }
  }
}
</script>
